import { Component, Input } from '@angular/core';

@Component({
    selector: 'al-bypass-block',
     template: `<a href="#content" id="skip-to-content" class="al-bypass-block focus-bypass-block">{{value}}</a>`
})

export class AlByPassBlockComponent {

    // value for bypass block.
    @Input() value: string = 'Press enter to skip to main content.';

}
